import BeerSvg from '../../assets/beer-128px.svg';
import WineSvg from '../../assets/wine-128px.svg';
import CocktailSvg from '../../assets/cocktail-128px.svg';

const iconMap = {
  beer: BeerSvg,
  wine: WineSvg,
  cocktail: CocktailSvg,
};

export type IDrinkIcon = keyof typeof iconMap;

type Props = {
  animate?: boolean;
  icon?: IDrinkIcon;
  size?: number;
};

const DrinkIcon = ({ animate, icon = 'beer', size = 64 }: Props) => {
  return (
    <div>
      <img
        src={iconMap[icon]}
        width={size}
        height={size}
        className={`${animate ? 'animate-bounce' : ''}`}
      />
    </div>
  );
};

export default DrinkIcon;
